import React from "react";
import { connect } from 'react-redux';
import {
    Card,
    CardBody,
    CardHeader,
    Button,
    Row,
    Col
} from "reactstrap";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import paypal from "assets/img/paypal.svg";
import { paymentSetMethod, paymentSetStep  } from '../../redux/actions/payments.action';

const subscriptionPrice = [0.99, 4.99, 9.99];

const CheckOutPayment = (props) => {
    const { t } = useTranslation(['plans']);
    const getDiscount = (time) => {
        if (props.paymentType === "subscription")
            switch (time) {
                case 12: return 25
                case 6: return 10
                case 3: return 5
                default: return 0;
            }
        else switch (time) {
            case 12: return 20
            case 6: return 8
            case 3: return 3
            default: return 0;
        }
    };
    return (
        <>
            <motion.div initial={{ opacity: 0.5, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                <Button className="backBtn" onClick={() => props.paymentSetStep(1)}>Back to card</Button>
            </motion.div>
            <Row>
                <Col xs="12">
                    <motion.div initial={{ opacity: 0.5, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                        <Card>
                            <CardHeader>Payment options</CardHeader>
                            <CardBody>
                                <Card className="cardPayment">
                                    <div className="payments">
                                        <div className="payment">
                                            <Row className={`paymentBody ${props.paymentMethod === "paypal" && `selected`}`} onClick={() => props.paymentSetMethod('paypal')}>
                                                <Col xs="10">
                                                    {t('checkout.paypal')}
                                                </Col>
                                                <Col xs="2" className="paymentMethod">
                                                    <img alt="paypal" src={paypal} />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Card>
                                <Button className="checkoutBtn" disabled={!props.paymentMethod} >{t('checkout.completeOrder')}</Button>
                            </CardBody>
                        </Card>
                    </motion.div>
                </Col>
            </Row>
        </>
    );
};

const mapStateToProps = (state) => {
    const { vip, subscriptionTime, paymentMethod, paymentType } = state.payments;
    return { vip, subscriptionTime, paymentMethod, paymentType };
};

const mapDispatchToProps = {
    paymentSetMethod,
    paymentSetStep
};

//export default Plans;
export default connect(mapStateToProps, mapDispatchToProps)(CheckOutPayment);